import { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { usePedidos } from '../../../../contexts/Pedidos';
import { useHistory } from 'react-router-dom';
import { RowListaClientes } from '../RowListaClientes';
import { PaginationTable } from '../../../../themes/components/PaginationTable';
import { VscArrowSmallDown, VscArrowSmallUp } from "react-icons/vsc";
import moment from 'moment';
import { Typography } from "@material-ui/core";
import ReactLoading from 'react-loading';
import { useClientes } from '../../../../contexts/Clientes';
import { ModalDetalheCliente } from "../../components/Modais/ModalDetalheCliente";

const useStyles = makeStyles({
  root: {
    width: '97.6%',
    margin: '0px 1em 0px 1em',
    border: '1px #ccc solid',
  },
  container: {
    maxHeight: '65vh',
  },
});

export function TabelaListaClientes() {
  const { clientesBusca, loadingBuscaClientes, buscarClientes } = useClientes();
  const classes = useStyles();
  const [showModalDetalheCliente, setShowModalDetalheCliente] = useState<boolean>(false);
  const [clienteSelecionado, setClienteSelecionado] = useState<string>("");
  const history = useHistory();


  const [currentPage, setCurrentPage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(10);
  const [pageCount, setPageCount] = useState<number>(0);
  const handleChangePage = (event: any, value: any) => { setCurrentPage(value) };
  const [clientesPage, setClientesPage] = useState<any>([]);


  const [orderBy, setOrderBy] = useState("");
  const [revertOrderBy, setReveterOrderBy] = useState(true);
  const [ordenedClientes, setOrdenedClientes] = useState<any>([]);

  //Define a seta de ordenação que vai aparecer o lado do nome da coluna
  function showOrderByIcon(option: string) {
    switch (option) {
      case "codigo":
        if (orderBy === option) {
          if (revertOrderBy) {
            return <VscArrowSmallDown size={20} />
          } else {
            return <VscArrowSmallUp size={20} />
          }
        } else {
          return <></>
        }
      case "nome":
        if (orderBy === option) {
          if (revertOrderBy) {
            return <VscArrowSmallDown size={20} />
          } else {
            return <VscArrowSmallUp size={20} />
          }
        } else {
          return <></>
        }
      case "cpfcnpj":
        if (orderBy === option) {
          if (revertOrderBy) {
            return <VscArrowSmallDown size={20} />
          } else {
            return <VscArrowSmallUp size={20} />
          }
        } else {
          return <></>
        }
      case "cidadeestado":
        if (orderBy === option) {
          if (revertOrderBy) {
            return <VscArrowSmallDown size={20} />
          } else {
            return <VscArrowSmallUp size={20} />
          }
        } else {
          return <></>
        }
      case "situacao":
        if (orderBy === option) {
          if (revertOrderBy) {
            return <VscArrowSmallDown size={20} />
          } else {
            return <VscArrowSmallUp size={20} />
          }
        } else {
          return <></>
        }
      default:
        return <></>
    }
  }

  //Mostrar modal do cliente
  const handleModal = (codcli: string) => {
    setShowModalDetalheCliente(true);
    setClienteSelecionado(codcli);
  }

  useEffect(() => {
    if (clientesBusca instanceof Array)
      setOrdenedClientes(clientesBusca);
  }, [clientesBusca])

  // This effect calculate the page number on filtered results
  useEffect(() => {
    if (ordenedClientes instanceof Array)
      setPageCount(Math.ceil(ordenedClientes.length / perPage));
  }, [perPage, ordenedClientes]);

  // This effect apply the filtered caracters on products and set an array only with matched results
  // Whenever have change in filtered the current page is set to 0, the initial page 
  useEffect(() => {
    if (ordenedClientes instanceof Array) {
      let tempClientes = [...ordenedClientes];

      if (revertOrderBy) {
        switch (orderBy) {
          case "codigo":
            tempClientes.sort(function (a, b) {
              let keyA = parseInt(a.codcli), keyB = parseInt(b.codcli);
              // Compare the 2 dates
              if (keyA < keyB) return -1;
              if (keyA > keyB) return 1;
              return 0;
            });
            break;
          case "nome":
            tempClientes.sort(function (a, b) {
              let keyA = a.nomcli, keyB = b.nomcli;
              // Compare the 2 dates
              if (keyA < keyB) return -1;
              if (keyA > keyB) return 1;
              return 0;
            });
            break;
          case "cpfcnpj":
            tempClientes.sort(function (a, b) {
              let keyA = a.cgccpf, keyB = b.cgccpf;
              // Compare the 2 dates
              if (keyA < keyB) return -1;
              if (keyA > keyB) return 1;
              return 0;
            });
            break
          case "cidadeestado":
            tempClientes.sort(function (a, b) {
              let keyA = a.cidcli, keyB = b.cidcli;
              // Compare the 2 dates
              if (keyA < keyB) return -1;
              if (keyA > keyB) return 1;
              return 0;
            });
            break
          case "situacao":
            tempClientes.sort(function (a, b) {
              let keyA = a.sitcli, keyB = b.sitcli;
              // Compare the 2 dates
              if (keyA < keyB) return -1;
              if (keyA > keyB) return 1;
              return 0;
            });
            break;
          default:
            break;
        }
      } else {

        switch (orderBy) {
          case "codigo":
            tempClientes.sort(function (a, b) {
              let keyA = parseInt(a.codcli), keyB = parseInt(b.codcli);
              // Compare the 2 dates
              if (keyA > keyB) return -1;
              if (keyA < keyB) return 1;
              return 0;
            });
            break;
          case "nome":
            tempClientes.sort(function (a, b) {
              let keyA = a.nomcli, keyB = b.nomcli;
              // Compare the 2 dates
              if (keyA > keyB) return -1;
              if (keyA < keyB) return 1;
              return 0;
            });
            break;
          case "cpfcnpj":
            tempClientes.sort(function (a, b) {
              let keyA = a.cgccpf, keyB = b.cgccpf;
              // Compare the 2 dates
              if (keyA > keyB) return -1;
              if (keyA < keyB) return 1;
              return 0;
            });
            break
          case "cidadeestado":
            tempClientes.sort(function (a, b) {
              let keyA = a.cidcli, keyB = b.cidcli;
              // Compare the 2 dates
              if (keyA > keyB) return -1;
              if (keyA < keyB) return 1;
              return 0;
            });
            break
          case "situacao":
            tempClientes.sort(function (a, b) {
              let keyA = a.sitcli, keyB = b.sitcli;
              // Compare the 2 dates
              if (keyA > keyB) return -1;
              if (keyA < keyB) return 1;
              return 0;
            });
            break;
          default:
            break;
        }
      }
      setCurrentPage(1);
      setOrdenedClientes(tempClientes);
    }
  }, [orderBy, revertOrderBy]);


  // This effect push the filtered registers in current page
  useEffect(() => {
    if (ordenedClientes instanceof Array) {
      let tempClientes = [];
      let maxReg = currentPage * perPage;
      for (let index = (currentPage - 1) * perPage; index < maxReg && index < ordenedClientes.length; index++) {
        if (ordenedClientes[index] !== undefined)
          tempClientes.push(ordenedClientes[index]);
      }
      setClientesPage(tempClientes);
    }
  }, [ordenedClientes, currentPage, perPage, orderBy, revertOrderBy, clientesBusca]);

  return (
    <>
      {loadingBuscaClientes ? <div className="loading-table-list-pedidos"><ReactLoading type={"bars"} color={"#0252a8"} height={30} width={50} /></div>
        :
        <>
          <TableContainer component={Paper} className={classes.root}>
            <Table stickyHeader aria-label="collapsible table">
              <TableHead>
                <TableRow>
                  <TableCell className="th-tabela-lista-pedidos" onClick={() => { setReveterOrderBy(revertOrderBy ? false : true); setOrderBy("codigo") }}>{showOrderByIcon("codigo")}Código</TableCell>
                  <TableCell className="th-tabela-lista-pedidos" onClick={() => { setReveterOrderBy(revertOrderBy ? false : true); setOrderBy("nome") }} align="left">{showOrderByIcon("nome")}Nome</TableCell>
                  <TableCell className="th-tabela-lista-pedidos" onClick={() => { setReveterOrderBy(revertOrderBy ? false : true); setOrderBy("cpfcnpj") }} align="left">{showOrderByIcon("cpfcnpj")}CPF/CNPJ</TableCell>
                  <TableCell className="th-tabela-lista-pedidos" onClick={() => { setReveterOrderBy(revertOrderBy ? false : true); setOrderBy("cidadeestado") }} align="left">{showOrderByIcon("cidadeestado")}Cidade/Estado</TableCell>
                  <TableCell className="th-tabela-lista-pedidos" onClick={() => { setReveterOrderBy(revertOrderBy ? false : true); setOrderBy("situacao") }} align="left">{showOrderByIcon("situacao")}Situação</TableCell>
                  <TableCell align="right" />
                </TableRow>
              </TableHead>
              <TableBody>
                {clientesPage !== null && clientesPage instanceof Array && clientesPage.length > 0 ? clientesPage.map((row, index) => (
                  <RowListaClientes key={row.codcli}
                    row={row}
                    handleModal={handleModal}
                    history={history}
                    index={index}
                  />
                )) : <TableRow><TableCell><Typography>Nenhum cliente encontrado.</Typography></TableCell></TableRow>}
                {pageCount > 1 && perPage - clientesPage.length > 0 && (
                  <TableRow style={{ height: 63 * (perPage - clientesPage.length) }} >
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <PaginationTable
            textSingle="Cliente"
            textPlural="Clientes"
            arrayItens={ordenedClientes}
            page={currentPage}
            countPages={pageCount}
            defaultPage={1}
            handleChange={handleChangePage}
            shape="round"
            setCurrentPage={setCurrentPage}
            setPerPage={setPerPage}
            optionsPerPage={[5, 10, 50]}
            perPage={perPage}
          />
        </>
      }
      <ModalDetalheCliente showModal={showModalDetalheCliente} codCli={clienteSelecionado} setShowModal={setShowModalDetalheCliente} />
    </>
  );
}